/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_State_UpcomingInputs */



/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Tournaments_State_UpcomingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_state_upcoming = /** @type {((inputs?: Tournaments_State_UpcomingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_State_UpcomingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("À venir")
	if (locale === "es") return /** @type {LocalizedString} */ ("Próximos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Próximos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prossimi")
	return /** @type {LocalizedString} */ ("Upcoming")
});